import { Field, Form, Formik } from "formik";
import Button from "pages/_components/Button";
import { DateRangeField } from "pages/_components/fields/DateRangeField";
import Selector from "pages/_components/fields/formik/Selector";
import TextField from "pages/_components/fields/TextField";
import I18n from "pages/_components/I18n";
import { func, instanceOf, shape, string } from "prop-types";
import React, { useEffect, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { actions as creditBillActions } from "reducers/creditBills";
import { creditBillStates, FORM_ID, getBoolOption, NEGOCIACION, NEGOCIACION_PENDIENTE } from "util/creditBills";
import { getLimitDate } from "util/date";
import * as i18n from "util/i18n";

const FilterForm = ({ customValues, closeSidebar, tabOption, customValidations }) => {
    const formRef = useRef(null);
    const dispatch = useDispatch();
    const { isEmitted, isInTenure, isReceived, isToPay } = getBoolOption(tabOption);
    const { filters } = useSelector((state) => state.creditBills);
    const statesOptions = i18n
        .formatOption(creditBillStates, "creditBill.states")
        .filter((item) => item.value !== NEGOCIACION && item.value !== NEGOCIACION_PENDIENTE);

    const initialValues = {
        issueDateRange: [null, null],
        paymentDueDateRange: [null, null],
        invoiceStatus: "TODOS",
        ...customValues,
    };

    useEffect(() => {
        if (!formRef.current) {
            return;
        }

        const _filters = Object.entries(filters);
        _filters.forEach((item) => {
            if (item[0] === "issueDateFrom") {
                formRef.current.setFieldValue("issueDateRange[0]", item[1]);
            }
            if (item[0] === "issueDateTo") {
                formRef.current.setFieldValue("issueDateRange[1]", item[1]);
            }
            if (item[0] === "paymentDueDateFrom") {
                formRef.current.setFieldValue("paymentDueDateRange[0]", item[1]);
            }
            if (item[0] === "paymentDueDateTo") {
                formRef.current.setFieldValue("paymentDueDateRange[1]", item[1]);
            }
            formRef.current.setFieldValue(item[0], item[1]);
        });
    }, [filters]);

    const handleSubmit = (values) => {
        const requestFilters = {
            ...filters,
            pageNumber: 1,
            issueDateFrom: values.issueDateRange[0],
            issueDateTo: values.issueDateRange[1],
            paymentDueDateFrom: values.paymentDueDateRange[0],
            paymentDueDateTo: values.paymentDueDateRange[1],
            invoiceStatus: values.invoiceStatus,
            holderCuit: values?.holderCuit === "" ? null : values?.holderCuit,
            buyerCuit: values?.buyerCuit === "" ? null : values?.buyerCuit,
            issuerCuit: values?.issuerCuit === "" ? null : values?.issuerCuit,
            billTab: tabOption,
        };
        dispatch(creditBillActions.setCreditBillFilters(requestFilters));
        dispatch(creditBillActions.getCreditBills(requestFilters));
        closeSidebar((state) => !state);
    };

    const handleReset = (setFieldValue) => {
        setFieldValue("issueDateRange", [null, null]);
        setFieldValue("paymentDueDateRange", [null, null]);
        setFieldValue("invoiceStatus", "TODOS");
        setFieldValue("holderCuit", "");
        setFieldValue("buyerCuit", "");
        setFieldValue("issuerCuit", "");
    };

    return (
        <div className="container">
            <I18n id="echecks.filter" component="h2" />
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                ref={formRef}
                validationSchema={customValidations}>
                {({ setFieldValue }) => (
                    <Form>
                        <Row>
                            {isEmitted && (
                                <>
                                    <Col xs={12} md={6}>
                                        <Field
                                            component={TextField}
                                            placeholder={i18n.get("creditBill.debtorCuit.placeholder")}
                                            idForm={FORM_ID}
                                            name="buyerCuit"
                                            type="text"
                                        />
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Field
                                            component={TextField}
                                            placeholder={i18n.get("creditBill.holderCuit.placeholder")}
                                            idForm={FORM_ID}
                                            name="holderCuit"
                                            type="text"
                                        />
                                    </Col>
                                </>
                            )}
                            {isInTenure && (
                                <>
                                    <Col xs={12} md={6}>
                                        <Field
                                            component={TextField}
                                            placeholder={i18n.get("creditBill.debtorCuit.placeholder")}
                                            idForm={FORM_ID}
                                            name="buyerCuit"
                                            type="text"
                                        />
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Field
                                            component={TextField}
                                            placeholder={i18n.get("creditBill.issuerCuit.placeholder")}
                                            idForm={FORM_ID}
                                            name="issuerCuit"
                                            type="text"
                                        />
                                    </Col>
                                </>
                            )}
                            {isReceived && (
                                <>
                                    <Col xs={12} md={6}>
                                        <Field
                                            component={TextField}
                                            placeholder={i18n.get("creditBill.holderCuit.placeholder")}
                                            idForm={FORM_ID}
                                            name="holderCuit"
                                            type="text"
                                        />
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Field
                                            component={TextField}
                                            placeholder={i18n.get("creditBill.issuerCuit.placeholder")}
                                            idForm={FORM_ID}
                                            name="issuerCuit"
                                            type="text"
                                        />
                                    </Col>
                                </>
                            )}
                            {isToPay && (
                                <>
                                    <Col xs={12} md={6}>
                                        <Field
                                            component={TextField}
                                            placeholder={i18n.get("creditBill.holderCuit.placeholder")}
                                            idForm={FORM_ID}
                                            name="holderCuit"
                                            type="text"
                                        />
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Field
                                            component={TextField}
                                            placeholder={i18n.get("creditBill.issuerCuit.placeholder")}
                                            idForm={FORM_ID}
                                            name="issuerCuit"
                                            type="text"
                                        />
                                    </Col>
                                </>
                            )}
                            <Col xs={12} md={6}>
                                <Field
                                    component={DateRangeField}
                                    idForm={FORM_ID}
                                    minDate={getLimitDate(-3650)}
                                    maxDate={getLimitDate(3650)}
                                    name="issueDateRange"
                                    dateFormat="dd/MM/yyyy"
                                    selectsRange
                                    showMonthYearDropdown
                                    scrollableMonthYearDropdown
                                    showGlobalPlaceholder
                                />
                            </Col>
                            <Col xs={12} md={6}>
                                <Field
                                    component={DateRangeField}
                                    idForm={FORM_ID}
                                    minDate={getLimitDate(-3650)}
                                    maxDate={getLimitDate(3650)}
                                    name="paymentDueDateRange"
                                    dateFormat="dd/MM/yyyy"
                                    selectsRange
                                    showMonthYearDropdown
                                    scrollableMonthYearDropdown
                                    showGlobalPlaceholder
                                />
                            </Col>
                            <Col xs={12} md={6}>
                                <Field
                                    idForm={FORM_ID}
                                    name="invoiceStatus"
                                    component={Selector}
                                    options={statesOptions}
                                    placeholder={i18n.get("accounts.create.choose")}
                                />
                            </Col>
                        </Row>
                        <Row className="form-actions">
                            <Col xs={12} md={6}>
                                <Button
                                    className="btn-outline"
                                    label="echecks.clean.filters"
                                    onClick={() => handleReset(setFieldValue)}
                                />
                            </Col>
                            <Col xs={12} md={6}>
                                <Button type="submit" className="btn-primary" label="echecks.filtering" />
                            </Col>
                        </Row>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

FilterForm.propTypes = {
    customValues: instanceOf(Object).isRequired,
    closeSidebar: func.isRequired,
    tabOption: string.isRequired,
    customValidations: shape({}).isRequired,
};

export default FilterForm;
